/*
 * Copyright (c) 2024. Tooling Team
 */

import PropTypes from "prop-types";
import { Checkbox } from "@uhg-abyss/web/ui/Checkbox";

export function AllTagsForm(props) {
  const { tags, setTags, tagType } = props;

  const handleChange = (checked, tag) => {
    const tempTags = { ...tags };
    tempTags[tagType][tag.id].selected = checked;
    setTags(tempTags);
  };

  return (
    <div>
      {tags[tagType].map((tag, i) => (
        <Checkbox
          isChecked={tag.selected}
          onChange={(e) => handleChange(e.target.checked, tag)}
          key={i}
        >
          {tag.name}
        </Checkbox>
      ))}
    </div>
  );
}

AllTagsForm.propTypes = {
  tags: PropTypes.object,
  tagType: PropTypes.string,
  setTags: PropTypes.func,
};
